import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Clickable from 'components/Common/Clickable'
import config from 'constants/config'
import Image from 'components/Common/Image'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import GeoContext from 'contexts/geoContext'
import { campaignRegionImages } from 'components/utils/tour-luxplus-campaign-regions'

const BannerImage = styled(Image)`
  padding-top: ${rem(5)};
  padding-bottom: ${rem(20)};
  width: 100%;
`

function TourCatalogueBannerTop() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)

  const images = campaignRegionImages[currentRegionCode as keyof typeof campaignRegionImages]

  if (!images) {
    return null
  }

  const altText = intl.formatMessage(
    {
      id: 'HeyLosB0wH',
      defaultMessage: 'Tour the world with us',
      description: 'Alt text for tour catalogue banner image',
    },
  )

  return <Clickable href={config.tourCatalogueLink} target="_blank" rel="noopener noreferrer">
    <CSSBreakpoint min="tablet">
      <BannerImage image={{ id: images.desktop }} alt={altText} />
    </CSSBreakpoint>
    <CSSBreakpoint max="mobile">
      <BannerImage image={{ id: images.mobile }} alt={altText} />
    </CSSBreakpoint>
  </Clickable>
}

export default TourCatalogueBannerTop
